import { secondAxios } from "../../api/axios";

export const getLicences = async () => {
  const { data } = await secondAxios.get("/licence");
  return data;
};

export const getLicence = async (id) => {
  const { data } = await secondAxios.get(`/licence/${id}`);
  return data;
};

export const createLicence = async (name) => {
  const { data } = await secondAxios.post("/licence", { name });
  return data;
};

export const updateLicence = async (id, name) => {
  const { data } = await secondAxios.patch(`/licence/${id}`, { name });
  return data;
};

export const deleteLicence = async (id) => {
  const { data } = await secondAxios.delete(`/licence/${id}`);
  return data;
};

export const assignModulesToLicence = async (licenceId, moduleIds) => {
  const { data } = await secondAxios.post(
    `/licence/assign-modules/${licenceId}`,
    { moduleIds: moduleIds ?? [] },
  );
  return data;
};

export const assignLicenceToUser = async (userId, licenceId) => {
  const { data } = await secondAxios.post(`/licence/assign/${userId}`, {
    licenceId: licenceId ?? null,
  });
  return data;
};

export const getUserLicence = async (userId) => {
  const { data } = await secondAxios.get(`/licence/user/${userId}`);
  return data;
};

export const getModules = async () => {
  const { data } = await secondAxios.get("/modules");
  return data;
};

export const getModulesByLicence = async (licenceId) => {
  const { data } = await secondAxios.get(`/modules/licence/${licenceId}`);
  return data;
};

export const createModule = async (name, licenceIds = []) => {
  const payload = { name };
  if (licenceIds?.length) {
    payload.licenceIds = licenceIds;
  }
  const { data } = await secondAxios.post("/modules", payload);
  return data;
};

export const updateModule = async (id, name) => {
  const { data } = await secondAxios.patch(`/modules/${id}`, { name });
  return data;
};

export const deleteModule = async (id) => {
  const { data } = await secondAxios.delete(`/modules/${id}`);
  return data;
};

export const getAllUsers = async () => {
  const { data } = await secondAxios.get("/user");
  return data;
};

export const getUsersWithLicences = async () => {
  const users = await getAllUsers();
  if (!Array.isArray(users)) return [];

  return Promise.all(
    users.map(async (user) => {
      try {
        const licence = await getUserLicence(user.id);
        const licenceId =
          licence?.id ?? user.licenceId ?? user.licence?.id ?? null;
        return { ...user, licenceId, licence: licence ?? null };
      } catch {
        return {
          ...user,
          licenceId: user.licenceId ?? user.licence?.id ?? null,
        };
      }
    }),
  );
};

export const getModuleLicenceIds = (module) => {
  if (Array.isArray(module?.licenceIds)) {
    return module.licenceIds.map(String);
  }
  if (Array.isArray(module?.licences)) {
    return module.licences.map((licence) => String(licence.id));
  }
  if (module?.licenceId) {
    return [String(module.licenceId)];
  }
  return [];
};

export const getLicenceModuleIds = (licence) => {
  if (Array.isArray(licence?.moduleIds)) {
    return licence.moduleIds.map(String);
  }
  if (Array.isArray(licence?.modules)) {
    return licence.modules.map((module) => String(module.id));
  }
  return [];
};

export const syncModuleLicences = async (moduleId, licenceIds, licences) => {
  const desired = new Set((licenceIds ?? []).map(String));
  const normalizedModuleId = String(moduleId);

  await Promise.all(
    (licences ?? []).map(async (licence) => {
      const currentIds = getLicenceModuleIds(licence);
      const shouldInclude = desired.has(String(licence.id));
      const hasModule = currentIds.includes(normalizedModuleId);

      if (shouldInclude && !hasModule) {
        await assignModulesToLicence(licence.id, [
          ...currentIds,
          normalizedModuleId,
        ]);
      } else if (!shouldInclude && hasModule) {
        await assignModulesToLicence(
          licence.id,
          currentIds.filter((id) => id !== normalizedModuleId),
        );
      }
    }),
  );
};
